exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes rotate-data-v-58fa6c37{0%{transform:rotate(0)}to{transform:rotate(1turn)}}div[data-v-58fa6c37]{display:inline-block}button[data-v-58fa6c37]:active,button[data-v-58fa6c37]:focus{outline:none!important;box-shadow:none!important}.is-loading[data-v-58fa6c37]:after{content:\"X\";margin:0 0 0 10px;height:15px;width:15px;border:2px solid transparent;border-bottom-color:#fff;border-top-color:#fff;border-right-color:#fff;border-radius:50%;font-size:0;line-height:0;vertical-align:text-top;display:inline-block;animation-name:rotate-data-v-58fa6c37;animation-duration:1s;animation-timing-function:ease-in-out;animation-iteration-count:infinite}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58fa6c37","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/partials/TDSButton.vue
// module id = 647
// module chunks = 0